export default __webpack_public_path__ + "static/graph-aa369072c27d16533c008410c741f0ff.png";